import { standardizeHeights } from '../../core/INF-gridAlignment';

const Blog = () => {
  // Check if there's at least one blog section element
  if (!document.querySelector('[data-section-type="INF-Blog"]')) {
    return;
  }

  const gridItemSelector = '[data-article-tile]';
  const childSelectors = ['[data-article-tile-image]', '[data-article-tile-title]', '[data-article-tile-excerpt]'];

  // Event handler to standardize heights on resize
  const handleResize = () => {
    standardizeHeights(gridItemSelector, childSelectors);
  };

  // Add resize event listener
  window.addEventListener('resize', handleResize);

  // Ensure to clean up this effect when the component is no longer needed
  return () => {
    window.removeEventListener('resize', handleResize);
  };
};

export { Blog };
